import UpRequest from "up-request";
import pkg from "../../../package.json";
import { getDefaultUA } from "@js/utils/tools";
const userAgent = getDefaultUA();

const upRequest = new UpRequest({
  UserAgent: userAgent,
  version: pkg.version,
});

export default function (service) {
  const { serviceFactory } = upRequest;
  return serviceFactory(service);
}



// WEBPACK FOOTER //
// ./js/_service/utils/getService.js